import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <UpdatesSection />
        <CommentsSection />
        <AboutSection />
        <CarouselSection />
        <RankingSection />
        <TopicsSection />
        <AppSection />
        <CardsSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}